import { Content } from "pdfmake/interfaces";

// 定义表格行数据类型
export interface ScoreRow {
  name: string; // 评分名称
  emissions: string; // 风险
  description: string;
  temperature: string; // 描述
}

/**
 * 生成情景表格文档内容
 * @param params 表格参数
 * @returns 格式化后的文档内容数组
 */
export function generateScoreContent(t: any): Content[] {
  const widths = ["20%", "20%", "40%", "20%"],
    heights = 40,
    headerLabels = [
      t("score.scenario"),
      t("score.emissions"),
      t("score.description"),
      t("score.temperature")
    ],
    rows: ScoreRow[] = [];

  for (let i = 1; i <= 4; i++) {
    rows.push({
      name: t(`score.scenario${i}`),
      emissions: t(`score.emissions${i}`),
      description: t(`score.description${i}`),
      temperature: t(`score.temperature${i}`)
    });
  }

  // 构建表格主体
  const tableBody: any[] = [
    // 表头行
    headerLabels.map((label) => ({
      text: label,
      style: "headerCell"
    }))
  ];

  // 添加数据行
  rows.forEach((row) => {
    tableBody.push([
      {
        text: row.name,
        marginTop: 7,
        alignment: "center"
      },
      {
        text: row.emissions,
        marginTop: 15,
        alignment: "center"
      },
      {
        text: row.description,
        padding: [5, 5, 5, 5]
      },
      {
        text: row.temperature,
        marginTop: 7
      }
    ]);
  });

  return [
    {
      text: t("appendix.subtitle2"),
      margin: [0, 0, 0, 20],
      bold: true,
      fontSize: 11
    },
    {
      table: {
        widths: widths,
        heights: heights,
        body: tableBody
      },
      layout: {
        hLineWidth: (i: number) => (i >= 0 ? 1 : 0),
        vLineWidth: (i: number, node: any) =>
          i === 0 || i === node.table.widths.length ? 1 : 0,
        hLineColor: () => "#006D73",
        vLineColor: () => "transparent",
        fillColor: (i: number) => (i % 2 === 1 ? "#f2f2f2" : null)
      },
      // pageBreak: "after"
    }
  ] as Content[];
}

export default generateScoreContent;
